/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import timeframeUnits from 'cio/utils/timeframe-units';
import integerToString from 'cio/utils/integer-to-string';
import WaitUntilAbstract, { MaximumWaitPath } from 'cio/app-models/action-abstracts/wait-until';

interface WaitUntilMaxWaitEditorArgs {
  actionAbstract: WaitUntilAbstract;
  isSaving: boolean;
  hasReadOnlyPermission: boolean;
}

export default class WaitUntilMaxWaitEditor extends Component<WaitUntilMaxWaitEditorArgs> {
  @integerToString('args.actionAbstract.maximumWaitPath.delayCount') delayCountValue!: string;

  readonly delayUnits = timeframeUnits({
    context: this.args.actionAbstract.maximumWaitPath as MaximumWaitPath,
    countProperty: 'delayCount',
  });
}
